// require('./stylesheets/receipt.sass');
require('./stylesheets/refill.scss');
angular.module('pages.serviceReceipt', [])
    .config(config);

config.$inject = ['$stateProvider'];
function config($stateProvider) {
    $stateProvider
        .state('pages.serviceReceipt', {
            url: 'service-receipt/:payment_id',
            template: require('./templates/index.html'),
            controller: require('./controllers/receipt.controller.js'),
            params: {
                payment_id: null
            },
        data: {
                restricted: false,
                iframe: true
            },
            pageTrack: '/service-receipt'
        })
}

module.exports = 'pages.serviceReceipt';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/serviceReceipt/index.js
 ** module id = 291
 ** module chunks = 1
 **/